import { Injectable } from '@angular/core';
import { FiltersTypeEnum, IFilterTextComponent, IFilterComboComponent, RankSortingLocatorComponent } from 'world-archery-lib';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { debounceTime, map, buffer, distinctUntilChanged, tap } from 'rxjs/operators';
import { bufferWhen } from 'rxjs-compat/operator/bufferWhen';
import { FiltersAbstractService } from '../../common-page-components/classes/filters-abstract-service';

@Injectable({
  providedIn: 'root'
})
export class EventsResultsFiltersService extends FiltersAbstractService {
  level_id = new BehaviorSubject<any>(undefined);
  filtersType: any = [
    {
      options: {
        type: FiltersTypeEnum.TextSearch,

        id: 'ertextfilter',
        defaultTextValue: '',
        text_subject: new BehaviorSubject('')
      } as IFilterTextComponent
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,

        name_filter: 'Level:',
        options_subject: new BehaviorSubject<Array<any>>([
          { name: 'All levels', id: [] },
          { name: 'International events', id: [1, 2, 3, 4, 8] },
          { name: 'Continental events', id: [5, 6, 7] },
          { name: 'National events', id: [9, 10] }

        ]),
        option_name_property: 'name',
        options_selected_subject: new BehaviorSubject<any>({ name: 'All levels' } as any),
        id: 'erdisciplinecombo'
      } as IFilterComboComponent
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,

        name_filter: 'World ranking:',
        options_subject: new BehaviorSubject<Array<any>>([
          { name: 'All'},
          { name: 'Yes', value: 1 },
          { name: 'No', value: -1 }
        ]),
        option_name_property: 'name',
        options_selected_subject: new BehaviorSubject<any>({
          name: 'All'
        } as any),
        id: 'wrankingworldrankingeventcombo'
      }
    },
  ];


  /**
   * A subject to set if is World Ranking Event.
   *
   * @type {BehaviorSubject<number>}
   * @memberof EventsResultsFiltersService
   */
  isWorldRankingEvent: BehaviorSubject<number> = new BehaviorSubject(undefined);

  /**
   * Variable for get the sync status of world ranking filter.
   *
   * @memberof EventsResultsFiltersService
   */
  isWorldRankingSet = false;
  /**
   *
   * Subject of page number
   * @memberof EventsResultsFiltersService
   */
  pageNumber = new BehaviorSubject(0);

  /**
   *
   * Subject of actual page
   * @memberof EventsResultsFiltersService
   */
  pageActual = new BehaviorSubject(0);

  /**
   *
   * Subject of total items in the page
   * @memberof EventsResultsFiltersService
   */
  totalItems = new BehaviorSubject(0);

  /**
   *
   * Subject of the selected items per page count
   * @memberof EventsResultsFiltersService
   */
  pageCount = new BehaviorSubject(10);

  readonly sortLocator = new RankSortingLocatorComponent();

  protected orderSubject: BehaviorSubject<
    RankSortingLocatorComponent
  > = new BehaviorSubject(this.sortLocator);

  constructor() {
    super();
    (<IFilterComboComponent>(
      this.filtersType[1].options
    )).options_selected_subject.asObservable()
      .pipe(distinctUntilChanged(),
        tap(a => this.pageNumber.next(0))
      ).pipe(
        tap(a => this.level_id.next(a))).pipe(
          tap(a => this.level_id.next(a))
        ).subscribe();
    this.sortLocator.asc = false;
    this.sortLocator.sortingType = 'DATE' as any;
  }

  /**
   *
   * Get an observable with all grouped filters of page
   * @returns {Observable<{
   *     text: string, //Belongs to text input
   *     level: Array<number>, //Array of levels id
   *     sort: RankSortingLocatorComponent, // sortLocator
   *     page_number: number, //Page number
   *     items_per_page: number, //Requested items per page
   *   }>}
   * @memberof EventsResultsFiltersService
   */
  public getDataStreamWithFilters(): Observable<{
    text: string,
    level: Array<number>,
    sort: RankSortingLocatorComponent,
    page_number: number,
    items_per_page: number,
    isWorldRanking: number | undefined,
  }> {
    return combineLatest(
      (<IFilterTextComponent>(
        this.filtersType[0].options
      )).text_subject.asObservable().pipe(debounceTime(300), distinctUntilChanged(), tap(a => this.pageNumber.next(0))),
      this.level_id.asObservable(),
      this.orderSubject.asObservable(),
      this.pageNumber.asObservable(),
      this.pageCount.asObservable(),
      (<IFilterComboComponent>(this.filtersType[2]).options).options_selected_subject.asObservable()

    ).pipe(map(([text, level_popular, sort, pageNumber, pageCount, isWorldRanking]) => {
      // Default values for sorts.

      let arr_level = [];
      if (level_popular.id.length === 0) {
      }
      arr_level = level_popular.id;
      const ret = {
        text: text,
        level: arr_level,
        sort: sort,
        page_number: pageNumber,
        items_per_page: pageCount,
        isWorldRanking: (isWorldRanking as any).value
      };
      this.isWorldRankingSet = (isWorldRanking as any).value != undefined ? (isWorldRanking as any).value : undefined;
      return ret;
    }))
  }

  generateDefaultValues(): void {

  }

  /**
   * Get subject of order value
   *
   * @readonly
   * @type {Observable<RankSortingLocatorComponent>}
   * @memberof EventsResultsFiltersService
   */
  get orderValue(): Observable<RankSortingLocatorComponent> {
    return this.orderSubject.asObservable();
  }

  /**
   * Modifies and send next sort locator
   *
   * @memberof EventsResultsFiltersService
   */
  public modifyOrderValue() {
    this.orderSubject.next(this.sortLocator);
  }
}
